import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '@services/profiles/profile.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-profiles',
    templateUrl: './profiles.component.html',
    styleUrls: ['./profiles.component.scss'],
    providers: [ProfileService, DialogService],
    standalone: false
})
export class ProfilesComponent implements OnInit {

  pageActions: PageAction[];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  columns = [{ prop: 'firstName', name: 'Firstname' }, { prop: 'lastName', name: 'Lastname' }, { prop: 'email', name: 'Email' }];

  dataProviderParams = { isAnonymous: 0, userType: 'ibexfusion' };

  constructor(public profileService: ProfileService, private router: Router, private dialogService: DialogService) {
  }

  ngOnInit() {
    this.createPageActions();
  }

  onDetail(event: DataTableEvent): void {
    this.router.navigate(['profiles', event.row.ProfileID]);
  }

  onEdit(event: DataTableEvent): void {
    this.router.navigate(['profiles', event.row.ProfileID, 'edit']);
  }

  async onRemove(event: DataTableEvent): Promise<any> {
    if (!await this.dialogService.confirm('Remove Profile?')) {
      return;
    }
    try {
      await this.profileService.remove(event.row.ProfileID);
      this.dataTable.refresh();
    } catch (error) {
      return this.dialogService.confirm(error?.error?.message || error?.message, error.name);
    }
  }

  createPageActions() {
    this.pageActions = [new PageAction({ icon: 'create', title: 'Create Profile', callback: () => { this.router.navigate(['profiles/create']); } })];
  }
}
